import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { LightboxComponent, LightboxInterface } from '@gosuite/lightbox';



@Component({
	selector: 'news-dialog',
	templateUrl: './news-dialog.component.html',
	styleUrls: ['./news-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsDialogComponent implements LightboxInterface {
	@ViewChild('lightboxInstance') public lightboxInstance: LightboxComponent;

	@Output() public onOpen: EventEmitter<any> = new EventEmitter();
	@Output() public onClose: EventEmitter<any> = new EventEmitter();
	@Output() public onClickCloseButton: EventEmitter<any> = new EventEmitter();
	@Output() public onClickBackground: EventEmitter<any> = new EventEmitter();
	@Output() public onEscapeKeyPress: EventEmitter<any> = new EventEmitter();

	@Input() public showCloseButton: boolean = true;
	@Input() public showHeader: boolean = false;
	@Input() public showFooter: boolean = true;
	@Input() public showBackground: boolean = true;
	@Input() public backgroundColor: string = null;
	@Input() public boxColor: string = null;
	@Input() public showBoxShadow: boolean = true;
	@Input() public boxWidth: string = '800px';
	@Input() public boxHeight: string = '400px';
	@Input() public closeByCloseButtonClick: boolean = true;
	@Input() public closeByBackgroundClick: boolean = true;
	@Input() public closeOnEscapeKey: boolean = true;
	@Input() public isFancy: boolean = false;
	@Input() public closeButtonFixed: boolean = false;
	@Input() public newsId: string = null;

	public isOpen: boolean = false;

	public open(): void {
		this.isOpen = true;
		this.lightboxInstance.open();
	}

	public close(): void {
		this.isOpen = false;
		this.lightboxInstance.close();
	}

	public handleLightboxOpen(): void {
		this.onOpen.emit();
	}

	public handleLightboxClose(): void {
		this.onClose.emit();
	}

	public handleClickCloseButton(): void {
		this.onClickCloseButton.emit();

		if (this.closeByCloseButtonClick) {
			this.close();
		}
	}

	public handleClickBackground(): void {
		this.onClickBackground.emit();

		if (this.closeByBackgroundClick) {
			this.close();
		}
	}

	public handleEscapeKeyPress(): void {
		this.onEscapeKeyPress.emit();

		if (this.closeOnEscapeKey) {
			this.close();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/news-dialog/news-dialog.component.ts